<div class="items">
  <div class="container bookmar-content">
    <div class="row row-1" (click)="Takemetoprime()" *ngIf="!limitreached && !isPrime">
      <div class="col mobile-alert">
        <div>
          <img class="alert-img-mobie" src="{{ constants.BOOKMARK_ALERT_IMG }}" src="" alt="" />
        </div>
        <div>
          <h4 class="alert-title-mobile">Oops, bookmark limit reached</h4>
          <p class="alert-content">
            Upgrade to WindowSwap All-Access for unlimited videos and more
          </p>
        </div>
      </div>
    </div>
    <div class="row" (click)="Takemetoprime()" *ngIf="!limitnotreached && !isLoading">
      <div class="col mobile-alert">
        <div>
          <img class="alert-img-mobie" src="{{ constants.BOOKMARK_ALERT_IMG }}" src="" alt="" />
        </div>
        <div>
          <h4 class="alert-title-mobile-1">Get Unlimited Bookmarks</h4>
          <p class="alert-content">
            Upgrade to WindowSwap All-Access for unlimited videos and more
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-6 test" [ngClass]="{ 'col-lg-4': !isPrime, 'col-lg-3': isPrime }" id="{{ item.videoId }}"
        *ngFor="let item of videoItem">
        <div>
          <button (click)="openFavWindow($event)" class="bookmard-window">
            <img name="{{ item.videoId }}" class="card-img-top" src="{{ item.thumbnail }}" alt="Card image cap" />
          </button>
          <div class="card-body bookmark-card">
            <button class="favorit-button" (click)="onClickShowConfirmPopup($event)">
              <img name="{{ item.videoId }}" class="favorite" [src]="constants.FAVORITE_IMG" alt="fav"
                ngbTooltip="Remove from Bookmarks" />
            </button>
            <h6 class="card-title bookmark-title">{{ item.author }}</h6>
            <a href="http://maps.google.co.in/maps?q={{ item.location }}" target="_blank" class="bookmark-sub-title">{{
              item.location }}</a>
          </div>
        </div>
      </div>
    </div>



    <div *ngIf="isLoading" class="row skelton-card">
      <div class="col-lg-3 col-md-4 col-6" *ngFor="let item of skeltonArray">
        <div>
          <button (click)="openFavWindow($event)" class="bookmard-window">
            <img name="{{ item.videoId }}" class="card-img-top" [src]="item" alt="Card image cap" />
          </button>
          <div class="card-body bookmark-card"></div>
        </div>
      </div>
    </div>
    <div class="row loadMore">
      <button class="button-accept" *ngIf="startKey !== undefined" [disabled]="isLoading"
        (click)="onBookmarkLoad()">Load more</button>
    </div>
    <div class="container empty-bookmark" *ngIf="isBookmarkEmpty">
      <div class="row">
        <div class="col-12">
          <img class="empty-bookmark-img" [src]="constants.EMPTY_BOOKMAR_IMG" alt="" />
          <h4 class="empty-bookmark-heading">
            {{ constants.ALL_THE_VIDEOS_TXT }}
          </h4>
          <p class="empty-bookmark-content">
            {{ constants.HIT_THE_TXT }}
            <span><img class="bookmark-img-icon" [src]="constants.BOOMARK_ICON_IMG" alt="" /></span>
            {{ constants.BUTTON_TO_TXT }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!limitreached && !isPrime" class="container bookmar-content-alert">
    <div class="alert-background">
      <h4 class="alert-title">Oops! Bookmark</h4>
      <h4 class="alert-title">limit reached.</h4>
      <img class="alert-img" src="{{ constants.BOOKMARK_ALERT_IMG }}" alt="card" />
      <div class="alert-div">
        <p class="alert-content text-center">Upgrade to</p>
        <p class="alert-content-1 text-center">WindowSwap All-Access</p>
        <p class="alert-content text-center">for unlimited bookmarks</p>
        <p class="alert-content text-center">and more .</p>
      </div>

      <button class="alert-button" (click)="Takemetoprime()">
        <span class="upgrade text-white">{{constants.MONTHLY_SUBSCRIPTION}}</span>
      </button>
    </div>
  </div>
  <div *ngIf="!limitnotreached" class="container bookmar-content-alert">
    <div class="alert-background">
      <h4 class="alert-title-1">Get Unlimited</h4>
      <h4 class="alert-title-1">Bookmarks</h4>
      <img class="alert-img" src="{{ constants.BOOKMARK_ALERT_IMG }}" alt="card" />
      <div class="alert-div">
        <p class="alert-content text-center">Upgrade to</p>
        <p class="alert-content-1 text-center">WindowSwap All-Access</p>
        <p class="alert-content text-center">for this and more</p>
      </div>

      <button class="alert-button" (click)="Takemetoprime()">
        <span class="upgrade text-white">{{constants.MONTHLY_SUBSCRIPTION}}</span>
      </button>
    </div>
  </div>
</div>
<!-- confirm modal -->

<div class="modal-popup" id="modal-popup-confirm" *ngIf="showconfirmModal">
  <div class="confirm-popup-content popup-content-confirm">
    <div class="popup-content-confirm-margin">
      <h1>{{constants.CONFIRM_DELETE_BOOKMARK_TEXT}} </h1>
      <h1>{{constants.CONFIRM_DELETE_BOOKMARK_TEXT_1}} </h1>
      <h1>{{constants.CONFIRM_DELETE_BOOKMARK_TEXT_2}} </h1>
    </div>
    <button [disabled]="isRemoving" type="button" class="yes-button" (click)="unbookmark()">
      <div *ngIf="isRemoving" class="spinner-border removing-spinner" role="status">
        <span class="sr-only">{{constants.LOADING_TEXT}}</span>
      </div>
      <div *ngIf="!isRemoving">{{constants.YES}}</div>
    </button>
    <button type="button" class="no-button" (click)=onClickCloseConfirmPopup()>
      {{constants.CANCEL}}
    </button>
  </div>
</div>